// extracted by mini-css-extract-plugin
module.exports = {"title":"_2dnue","information":"rcgi8","information__email":"_3ZpaX","resend":"_35JqP","resend__title":"_2H8iP","resend__send-email":"_28VjI"};